import React, { useEffect, useState } from "react";
import axios from "axios";
import CotizacionesNav from "./CotizacionesNav";

const BASE = process.env.REACT_APP_API_BASE || "http://localhost/twinpack/php";

const fmtFecha = (str) => {
  if (!str) return "—";
  const d = new Date(str);
  return d.toLocaleDateString("es-AR", { day: "2-digit", month: "2-digit", year: "numeric" });
};

const fmtMonto = (monto, moneda) => {
  if (!monto) return "—";
  const n = parseFloat(monto);
  const fmt = n.toLocaleString("es-AR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return (moneda === "USD" ? "USD " : "$") + fmt;
};

const S = {
  page: {
    minHeight: "100vh",
    background: "#f7f4f6",
    padding: "0 0 40px",
    fontFamily: "'Segoe UI', system-ui, sans-serif",
  },
  inner: {
    maxWidth: 1100,
    margin: "0 auto",
    padding: "28px 24px 0",
  },
  headerRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 20,
    flexWrap: "wrap",
    gap: 12,
  },
  title: {
    fontSize: 22,
    fontWeight: 700,
    color: "#222",
  },
  sub: {
    fontSize: 13,
    color: "#888",
    marginTop: 2,
  },
  card: {
    background: "#fff",
    borderRadius: 14,
    border: "1.5px solid #f0e6ec",
    boxShadow: "0 1px 4px rgba(0,0,0,0.07)",
    overflow: "hidden",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    fontSize: 13,
  },
  th: {
    background: "#9f0059",
    color: "#fff",
    fontWeight: 700,
    padding: "11px 14px",
    textAlign: "left",
    fontSize: 12,
    letterSpacing: "0.04em",
    textTransform: "uppercase",
  },
  td: {
    padding: "10px 14px",
    borderBottom: "1px solid #f0e6ec",
    color: "#333",
    verticalAlign: "middle",
  },
  motivoBadge: {
    display: "inline-block",
    background: "#fef2f2",
    color: "#dc2626",
    border: "1px solid #fecaca",
    borderRadius: 8,
    padding: "2px 10px",
    fontSize: 12,
    fontWeight: 600,
  },
  select: {
    fontSize: 13,
    padding: "6px 10px",
    borderRadius: 7,
    border: "1.5px solid #e0d6dc",
    background: "#fff",
    color: "#444",
    cursor: "pointer",
    outline: "none",
  },
  empty: {
    textAlign: "center",
    padding: "48px 24px",
    color: "#aaa",
    fontSize: 14,
  },
};

const CotizacionesRechazadas = () => {
  const [rechazadas, setRechazadas] = useState([]);
  const [loading,    setLoading]    = useState(true);
  const [meses,      setMeses]      = useState(12);

  const cargar = (m) => {
    setLoading(true);
    axios.post(`${BASE}/buscar_rechazadas.php`, new URLSearchParams({ meses: m }))
      .then(r => setRechazadas(Array.isArray(r.data) ? r.data : []))
      .catch(() => setRechazadas([]))
      .finally(() => setLoading(false));
  };

  useEffect(() => { cargar(meses); }, [meses]);

  return (
    <div style={S.page}>
      <CotizacionesNav />
      <div style={S.inner}>
        <div style={S.headerRow}>
          <div>
            <p style={S.title}>Cotizaciones rechazadas</p>
            <p style={S.sub}>{rechazadas.length} resultado{rechazadas.length !== 1 ? "s" : ""}</p>
          </div>
          <select style={S.select} value={meses} onChange={e => setMeses(Number(e.target.value))}>
            <option value={3}>Últimos 3 meses</option>
            <option value={6}>Últimos 6 meses</option>
            <option value={12}>Últimos 12 meses</option>
            <option value={24}>Últimos 2 años</option>
          </select>
        </div>

        <div style={S.card}>
          {loading ? (
            <p style={S.empty}>Cargando…</p>
          ) : rechazadas.length === 0 ? (
            <p style={S.empty}>No hay cotizaciones rechazadas en el período seleccionado.</p>
          ) : (
            <table style={S.table}>
              <thead>
                <tr>
                  <th style={S.th}>#</th>
                  <th style={S.th}>Fecha</th>
                  <th style={S.th}>Cliente</th>
                  <th style={S.th}>Proveedor</th>
                  <th style={S.th}>Motivo</th>
                  <th style={S.th}>Monto</th>
                  <th style={S.th}>Usuario</th>
                </tr>
              </thead>
              <tbody>
                {rechazadas.map((r, i) => (
                  <tr key={r.id} style={{ background: i % 2 === 0 ? "#fff" : "#fdf8fb" }}>
                    <td style={S.td}>{r.id}</td>
                    <td style={S.td}>{fmtFecha(r.created_at)}</td>
                    <td style={{ ...S.td, fontWeight: 600 }}>{r.cliente || "—"}</td>
                    <td style={S.td}>{r.proveedor || "—"}</td>
                    <td style={S.td}>
                      {r.motivo_rechazo
                        ? <span style={S.motivoBadge}>{r.motivo_rechazo}</span>
                        : <span style={{ color: "#ccc" }}>Sin motivo</span>
                      }
                    </td>
                    <td style={S.td}>{fmtMonto(r.monto_total, r.moneda)}</td>
                    <td style={{ ...S.td, color: "#888" }}>{r.usuario || "—"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};

export default CotizacionesRechazadas;
